import { useState } from 'react';
import { Flex, InputBox, Typography } from '@banhala/ui-kit';
import { ApiError } from 'shared/src/api/httpClient';
import { bridge } from 'shared/src/utils';
import { usePostInvitationAccept } from './queries/usePostInvitationAccept';

/**
 * 가입완료 드로어의 초대코드 입력(선택). 코드 확인 성공 시 입력/버튼 잠금.
 * (webview InvitationCodeForm 대응)
 */
export const InvitationCodeForm = () => {
  const { mutateAsync: acceptInvitation } = usePostInvitationAccept();
  const [code, setCode] = useState('');
  const [accepted, setAccepted] = useState(false);

  const handleVerify = async () => {
    if (code === '' || accepted) return;
    try {
      await acceptInvitation({ code });
      setAccepted(true);
    } catch (error) {
      bridge.toast(
        error instanceof ApiError && error.message
          ? error.message
          : '초대코드 확인에 실패했어요',
      );
    }
  };

  const disabled = code === '' || accepted;

  return (
    <Flex gap={8}>
      <Typography type={'subtitle2'} color={'content_primary'}>
        {'초대코드'}
      </Typography>
      <Flex horizontal alignItems={'center'} gap={8}>
        <Flex flex={1}>
          <InputBox
            type={'underline'}
            placeholder={'초대코드 입력 (선택사항)'}
            value={code}
            onChangeText={setCode}
          />
        </Flex>
        <Flex
          alignItems={'center'}
          justifyContent={'center'}
          height={44}
          padding={{ horizontal: 16 }}
          borderRadius={8}
          backgroundColor={disabled ? 'bg_secondary' : 'bg_black_button'}
          onPress={handleVerify}
        >
          <Typography
            type={'body2'}
            color={disabled ? 'content_tertiary' : 'content_always_white'}
          >
            {accepted ? '인증 완료' : '코드 확인'}
          </Typography>
        </Flex>
      </Flex>
    </Flex>
  );
};
